import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { forgotPasswordEmail, otpVerify } from '../../../redux/reducers/authSlice';
import { verifyOtpFromValidator } from '../../../services/validatior/formValidator/authValidator';
import { useFormik } from 'formik';
const VerifyOtp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation()
  const verifyOtpFormik = useFormik({
    initialValues: verifyOtpFromValidator.initialValues,
    validationSchema: verifyOtpFromValidator.validationSchema,
    onSubmit: async (values) => {
      let data = { otp: values?.otp, email: location?.state }
      dispatch(otpVerify({
        apiData: data,
        navigate: navigate,
        verifyOtpFormik: verifyOtpFormik
      }))
      // navigate('/verifyemail',{state:forgotPassFormik?.values.email})

    }
  })
  const resendOtp = () => {
    dispatch(forgotPasswordEmail({
      apiData: { email: location?.state },
      navigate: navigate,
    }))

  }
  useEffect(() => {
    if (!location?.state) {
      navigate('/')

    }
  }, [])

  const handleInputChangeForOtp = (e) => {
    e.target.value = e.target.value.replace(/\D/g, ''); // Filter out non-digit characters
    verifyOtpFormik.handleChange(e); // Call Formik's handleChange with the modified event
  };

  return (
    <>
      <div className="authentication-wrapper authentication-basic px-4 verify-m">
        <div className="authentication-inner position-relative py-4">
          {/* Verify Email */}
          <div className="card verify-card ">
            <div className="card-body">
              <div className="app-brand auth-logo">
                <img src="/assets/images/OHC-Logo.png" alt="" />
              </div>
              <div className="app-brand justify-content-start">
                <p className="app-brand-link gap-2">

                  <span className="app-brand-text demo text-body fw-bold ms-1">

                  </span>
                </p>
              </div>
              {/* /Logo */}
              <h4 className="mb-1 pt-2">Verify your OTP ✉️</h4>
              <p className="text-start mb-4">
                An OTP  sent to your email address:{location?.state}.Please enter the OTP  to continue.

              </p>
              {/* <p className="btn btn-primary w-100 mb-3" onClick={() => navigate('/login')}>
                Skip for now
              </p> */}

              <form onSubmit={verifyOtpFormik.handleSubmit}>
                <div className="mb-3">
                  {/* <label htmlFor="email" className="form-label">
                    Otp
                  </label> */}
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    name="otp"
                    value={verifyOtpFormik?.values.otp}
                    onChange={handleInputChangeForOtp}
                    placeholder="Enter your OTP"
                    autofocus=""
                  />
                  <p className='form-error-message'>{verifyOtpFormik.touched.otp &&
                    verifyOtpFormik.errors.otp}</p>
                </div>

                <button className="btn w-100 mb-3" type="submit">
                  Verify OTP
                </button>
                <p className="text-center mb-0">
                  Didn't get the OTP?
                  <span className='colour-red' style={{ cursor: "pointer" }} onClick={resendOtp}>Resend</span>
                </p>
              </form>
            </div>
          </div>
          {/* /Verify Email */}
        </div>
      </div>

    </>
  );
};



export default VerifyOtp;
